/**
 * Translates strings...
* @todo: Replace all strings to translate with the trans function
 */
const { __, _x, _n, _nx } = wp.i18n;

let plek_lang = {

    defaultLanguage: 'de_DE',
    activeLanguages: [],
    de_DE: {
        'Photo rights - What are you allowed to do': 'Fotorechte - Was du machen darfst',
        'Share Page': 'Seite teilen',
        'Share Photo': 'Foto teilen',
        'Save Photo': 'Speichere Foto',
        'Copy link to Photo': 'Kopiere link zum Foto',
        'Close': 'Schliessen',
    },

    /**
     * Initializes the language settings.
     * 
     * If the global `plek_language_vars` is defined, it sets the default language and
     * the list of active languages based on the provided variables.
     */

    construct() {
        if (typeof plek_language_vars !== 'undefined') {
            this.defaultLanguage = plek_language_vars.current_language;
            this.activeLanguages = plek_language_vars.available_languages;
        }
    },

    /**
     * Prompts the user to select a language from the available languages.
     * If the user selects a valid language, it returns the corresponding language code.
     * If no valid selection is made, it returns the current language code.
     *
     * @returns {string} The selected language code or the current language code.
     */

    prompt_language() {
        languages = this.get_available_languages(true);
        languages_obj = this.get_available_languages();
        prompted_language = prompt(__('What language do you want to use?', 'plekvetica') + '\n ' + languages);
        if (!empty(languages_obj[prompted_language])) {
            return languages_obj[prompted_language];
        }
        return this.current_language();
    },
    /**
     * Retrieves the list of available languages.
     * 
     * @param {boolean} returnString - If true, returns a formatted string of languages.
     *                                 If false, returns an array of active languages.
     * @returns {string|array} A formatted string of languages if returnString is true,
     *                         otherwise an array of active languages.
     */

    get_available_languages(returnString = false) {
        if (!returnString) {
            return this.activeLanguages;
        }
        let string = '';
        for (const [id, value] of Object.entries(this.activeLanguages)) {
            string += id + ' - ' + value + '\n';
        }
        return string;
    },

    /**
     * Translates a String
     * @param {string} string 
     * @returns string The translated string
     */
    trans(string) {

        if (typeof this.de_DE[string] !== 'undefined') {
            return this.de_DE[string];
        }
        return string;
    },

    /**
     * Returns the language code like de_DE or de
     * @param {bool} short If the language should be returned as a short version, e.g. en, de,
     * @returns {string} The language code
     */
    get_current_language(short = false) {
        const default_lang = 'de';
        const default_lang_full = 'de_DE';
        if (!short) {
            const locale_full = jQuery('html').attr('lang');
            return (!empty(locale_full)) ? locale_full : default_lang_full;
        }
        const locale = jQuery('html').attr('lang');
        if (typeof locale !== 'undefined' && locale.length > 0) {
            const locale_parts = locale.split('-');
            return locale_parts[0].toLocaleLowerCase();
        } else {
            return default_lang;
        }
    },

    /**
     * Gets the date format by the language set
     * @returns {string} Date format
     */
    get_current_date_format() {

        const locale = jQuery('html').attr('lang');
        switch (locale) {
            case 'de-DE':
                return "d-m-Y";
                break;

            default:
                return "Y-m-d";
                break;
        }

    }




}

plek_lang.construct();
window.plek_lang = plek_lang;
